'use client'

import { useLogout } from './useLogout'
import { PrimaryButton } from '@/src/shared/ui/button/PrimaryButton'
import { SecondaryButton } from '@/src/shared/ui/button/SecondaryButton'
import { Typography } from '@/src/shared/ui/typography'
import { LogOut } from 'lucide-react'

interface LogoutButtonProps {
  locale?: string
  label?: string
  redirectPath?: string
  className?: string
  variant?: 'primary' | 'secondary' | 'text'
  onClick?: () => void
  showIcon?: boolean
}

/**
 * Feature: Logout Button
 * Кнопка выхода из системы
 */
export function LogoutButton({
  locale = 'en',
  label = 'Logout',
  redirectPath,
  className,
  variant = 'secondary',
  onClick,
  showIcon = true
}: LogoutButtonProps) {
  const { handleLogout } = useLogout({ locale, redirectPath })

  const onLogoutClick = () => {
    console.log('👆 [LogoutButton] Button clicked', { 
      locale, 
      redirectPath, 
      variant 
    })
    
    try {
      handleLogout()
      console.log('✅ [LogoutButton] handleLogout called')
      
      onClick?.()
      console.log('✅ [LogoutButton] Custom onClick callback called')
    } catch (error) {
      console.error('❌ [LogoutButton] Error in onLogoutClick:', error)
    }
  }

  if (variant === 'text') {
    return (
      <button
        onClick={onLogoutClick}
        className={`text-accent-primary hover:text-accent-secondary transition-colors ${className || ''}`}
      >
        <Typography variant="body" color="inherit">
          {label}
        </Typography>
      </button>
    )
  }

  if (variant === 'primary') {
    return (
      <PrimaryButton onClick={onLogoutClick} className={className}>
        {showIcon && <LogOut className="h-4 w-4" />}
        {label}
      </PrimaryButton>
    )
  }

  return (
    <SecondaryButton onClick={onLogoutClick} className={className}>
      {showIcon && <LogOut className="h-4 w-4" />}
      <Typography variant="body" color="inherit">
        {label}
      </Typography>
    </SecondaryButton>
  )
}
